import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './DenunciaPerditeCase.scss';

const DenunciaPerditeCase = () => (
  <div className="DenunciaPerditeCase" data-testid="DenunciaPerditeCase">
    <CaseGenerator type={CaseForms.DenunciaPerdite}
                   excludeSteps={[]}
    />
  </div>
);

export default DenunciaPerditeCase;
